// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__VF9es","projects":"Projects_projects__rTIRo","project_card__container":"Projects_project_card__container__hEdec"};